import { Form, Formik } from "formik";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  currentTenant,
  financialyearend,
  financialyearstart,
  thousandsdisplay,
  userid,
} from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import InventoryService from "../InventoryService.js";
import {
  Autocomplete,
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
  createTheme,
  makeStyles,
} from "@mui/material";
import MUIDataTable, { ExpandButton, TableViewCol } from "mui-datatables";
import { NumericFormat } from "react-number-format";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const theme = createTheme({
  overrides: {
    MuiTable: {
      root: {
        border: [[1, "solid", "#d3d3d3"]],
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
        textAlign: "center !important",
        alignItems: "center",
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
  stickyFooterCell: {
    position: "sticky",
    bottom: 0,
    zIndex: 100,
  },
});

class Transactionreports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      filtereddata: [],
      productiondata: [],
      fromdate: moment(new Date()).subtract(14,'days'),
      todate: new Date(),
      itemlist: [],
      item: "",
      itemid: "",
      showsearchbar: false,
      search: "",
      page: 0,
      rowsPerPage: 10,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    // this.clearfilter = this.clearfilter.bind(this);
  }

  onSubmit = () => {
    let datadao = {
      tenantid: currentTenant,
      startdate: this.state.fromdate,
      enddate: this.state.todate,
      userid: userid,
      dataaccess: "",
      itemid: this.state.itemid,
    };
    InventoryService.getStocktransactionData(datadao).then((response) =>
      this.setState({
        data: response.data,
        filtereddata: response.data
          // .filter((e) => e.inventorytype !== "Production Store Inventory")
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)),
      })
    );
  };

  handleitemname = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      let datadao = {
        tenantid: currentTenant,
        startdate: this.state.fromdate,
        enddate: this.state.todate,
        userid: userid,
        dataaccess: "",
        itemid: values.itemid,
      };
      this.setState({
        itemid: values.id,
        item: values.name,
      });
      InventoryService.getStocktransactionData(datadao).then((response) =>
        this.setState({
          data: response.data,
          filtereddata: response.data
            .filter((e) => e.inventorytype !== "Production Store Inventory")
            .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)),
        })
      );
    } else {
      this.setState({
        itemid: "",
        item: "",
      });
    }
  };

  handleFromDateChange = (date) => {
    this.setState({
      fromdate: date,
      todate:
        moment(date).diff(this.state.todate, "days") >= 0
          ? this.state.todate
          : date,
    });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  Search = (val) => {
    this.setState({
      search: val,
      filtereddata: this.state.data.filter(
        (e) =>
          e.itemname.toLowerCase().includes(val.toLowerCase()) ||
          e.custombatchid?.toLowerCase().includes(val.toLowerCase())
      ),
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    // let datadao = {
    //   tenantid: currentTenant,
    //   startdate: financialyearstart,
    //   enddate: financialyearend,
    //   userid: userid,
    //   dataaccess: "",
    // };
    InventoryService.retriveAllItems(currentTenant).then((response) =>
      this.setState({ itemlist: response.data })
    );
    // InventoryService.getStocktransactionData(datadao).then((response) =>
    //   this.setState({
    //     data: response.data.sort((a, b) =>
    //       a.createdAt < b.createdAt ? 1 : -1
    //     ),
    //   })
    // );
  }

  validate(values) {
    let errors = {};
    if (values.from <= values.to && values.to === false) {
      alert("To date must be greater than From date");
      errors.to = "To date must be greater than From date";
    }
    if (values.from === null) {
      alert("Please Select From date");
      errors.from = "Please Select From date";
    }
    if (!values.to === null) {
      alert("Please Select to date");
      errors.to = "Please Select to date";
    }
    return errors;
  }

  render() {
    const columns = [
      // {
      //   name: "itemname",
      //   label: "Item name",
      //   options: {
      //     filter: false,
      //     sort: true,
      //     setCellProps: () => ({ align: "center" }),
      //   },
      // },
      {
        name: "rawmaterials",
        label: "Raw Material",
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: "createdAt",
        label: "Date",
        options: {
          filter: false,
          sort: true,
          sortOrder: "asc",
          customBodyRender: (value) => {
            return moment(value).format("DD.MM.YYYY");
          },
        },
      },
      {
        name: "custombatchid",
        label: "Batch",
        options: {
          filter: false,
          sort: true,
        },
      },
      
      {
        name: "refid",
        label: "Reference Id",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value,tableMeta) => {
            return (
              value !== null && tableMeta.rowData[6] === "Production"?
              <Link to="/productionstoreitemtransactionreports" state={{id:value}}>{value}</Link>
              :value
            );
          },
          setCellProps: () => ({ align: "center" }),
        },
      },
      {
        name: "type",
        label: "Type",
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "from",
        label: "From",
        options: {
          filter: false,
          sort: true,
        },
      },

      {
        name: "to",
        label: "To",
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: "previousstock",
        label: "Opening",
        options: {
          filter: false,
          sort: true,
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "inquantity",
        label: "Inward",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <span className="text-success">{value > 0 ? value : 0}</span>
            );
          },
          setCellProps: () => ({ align: "right" }),
        },
      },
      {
        name: "outquantity",
        label: "Outward",
        options: {
          filter: false,
          sort: true,
          sortOrder: "asc",
          customBodyRender: (value) => {
            return <span className="text-danger">{value < 0 ? value : 0}</span>;
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "totalstock",
        label: "Closing",
        options: {
          filter: false,
          sort: true,
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "productionremaining",
        label: "Remaining stock(Production)",
        options: {
          filter: false,
          sort: true,
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      }
      
    ];

    const shouldShowExpandIcon = (rowData, rowMeta) => {
      // Your condition to determine if the icon should be shown or hidden for a specific row.
      // You can access rowData and rowMeta to make your decision.
      return rowMeta.dataIndex[0] !== null && rowMeta.dataIndex[0]?.length>0; // Example condition (show icon only for John Doe)
    };

    const options = {
      filterType: "checkbox",
      selectableRows: "none",
      // resizableColumns: true,
      expandableRows: true,
      expandableRowsHeader: false,
      expandableRowsOnClick: true,

      onDownload: (buildHead, buildBody, columns, data) => {
        return "\uFEFF" + buildHead(columns) + buildBody(data); 
    } ,
    downloadOptions:{
      filename:`Inventory Ledger (${this.state.item})`,
      separator:",",
      filterOptions:{
        useDisplayedColumnsOnly:true,
        useDisplayedRowsOnly:true
      }
    },

      // customRowRender: (dataIndex, rowData, updateData) => {
      //   console.log(dataIndex, rowData,updateData);
      //   const showExpandIcon = shouldShowExpandIcon(rowData, { dataIndex });
      //   return (
      //     <tr key={dataIndex}>
      //       <td>
      //         {showExpandIcon ? (
      //           <span
      //             className="MuiIconButton-label"
      //             onClick={() => updateData(dataIndex)}
      //           >
      //             {/* Your custom expand icon */}
      //             [+] Expand
      //           </span>
      //         ) : null}
      //       </td>
      //         <td>{dataIndex[1]}</td>
      //          <td>{dataIndex[2]}</td>
      //          <td>{dataIndex[3]}</td>
      //          <td>{dataIndex[4]}</td>
      //          <td>{dataIndex[5]}</td>
      //          <td>{dataIndex[6]}</td>
      //          <td>{dataIndex[7].props.children}</td>
      //          <td>{dataIndex[8].props.children}</td>
      //          <td>{dataIndex[9]}</td>

      //     </tr>
      //   );
      // },

      // customTableBodyFooterRender: function (opts, opt2) {
      //   let avgAge = opts.data.reduce((accu, item) => {
      //     return accu + item.data[8].props.children;
      //   }, 0);

      //   let avgSalary = opts.data.reduce((accu, item) => {
      //     return accu + item.data[9].props.children;
      //   }, 0);

      //   avgAge = Math.round(avgAge);
      //   avgSalary = Math.round(avgSalary);

      //   return (
      //     <TableFooter>
      //       <TableRow style={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
      //         {opts.selectableRows !== "none" ? <TableCell /> : null}
      //         {opts.columns.map((col, index) => {
      //             if (col.label === "Batch") {
      //               return (
      //                 <TableCell
      //                   key={index}
      //                   className="text-black text-bold"
      //                   style={{
      //                     fontSize: "0.875rem",
      //                     letterSpacing: "0.01071em",
      //                     fontWeight: "500",
      //                   }}
      //                 >
      //                   Total
      //                 </TableCell>
      //               );
      //             }
      //             if (col.label === "Inward") {
      //               return (
      //                 <TableCell
      //                   key={index}
      //                   className="text-success text-right"
      //                   style={{
      //                     fontSize: "0.875rem",
      //                     letterSpacing: "0.01071em",
      //                     fontWeight: "500",
      //                   }}
      //                 >
      //                   {avgAge}
      //                 </TableCell>
      //               );
      //             } else if (col.label === "Outward") {
      //               return (
      //                 <TableCell
      //                   key={index}
      //                   className="text-danger text-right"
      //                   style={{
      //                     fontSize: "0.875rem",
      //                     letterSpacing: "0.01071em",
      //                     fontWeight: "500",
      //                   }}
      //                 >
      //                   {avgSalary}
      //                 </TableCell>
      //               );
      //             } else {
      //               return <TableCell key={index} />;
      //             }
      //           return null;
      //         })}
      //       </TableRow>
      //     </TableFooter>
      //   );
      // },

      renderExpandableRow: (rowData, rowMeta) => {
        return rowData[0] !== null && rowData[0].length > 0 ? (
          <tr>
            <td colSpan={6}>
              <TableContainer>
                <Typography>Raw materials</Typography>
                <Table
                  className=""
                  size="small"
                  style={{ margin: "0 auto" }}
                >
                  <TableHead>
                    <TableCell align="right">ItemName</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                  </TableHead>
                  <TableBody>
                    {rowData[0].map((row) => {
                      return (
                        <TableRow key={row.id}>
                          <TableCell component="th" scope="row" align="right">
                            {row.itemname}
                          </TableCell>
                          <TableCell align="right">
                            {row.quantity}({row.uom})
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </td>
          </tr>
        ) : (
          ""
        );
      },
    };

    // const components = {
    //   ExpandButton: function (props) {
    //     console.log(props);
    //     if (props.dataIndex === 3 || props.dataIndex === 4)
    //       return <div style={{ width: "24px" }} />;
    //     return <ExpandButton {...props} />;
    //   },
    //   TableViewCol: function (props) {
    //     return <TableViewCol {...props} />;
    //   }
    // };

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card card-info">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/inventory">Home</Link>
              </li>
              <li className="breadcrumb-item active">
                Inventory Ledger / Stock Transaction Report
              </li>
            </ol>
            <div className="card-body">
              <div className="text-center">
                {this.state.loading === true ? (
                  <div className="text-center">{spin}</div>
                ) : (
                  <Formik
                    initialValues={{
                      from: this.state.fromdate,
                      to: this.state.todate,
                    }}
                    onSubmit={this.onSubmit}
                    validateOnChange={false}
                    validate={this.validate}
                    enableReinitialize={true}
                  >
                    {(values) => (
                      <Form autoComplete="off" className="row">
                        <fieldset className="col-md-3">
                          <Autocomplete
                            id="subaccount"
                            className="subacc-select"
                            name="item"
                            options={this.state.itemlist}
                            getOptionLabel={(option) => option.name}
                            value={values.item ? undefined : undefined}
                            onChange={this.handleitemname}
                            renderInput={(params) => (
                              <FormikTextField
                                {...params}
                                className="form-control"
                                type="text"
                                name="name"
                                value={this.state.item}
                                label={`Select Item (${this.state.item})`}
                                variant="standard"
                                fullWidth
                              />
                            )}
                          />
                        </fieldset>
                        <fieldset className="col-md-12 p-2" />
                        {this.state.itemid === "" ||
                        this.state.itemid === null ? (
                          ""
                        ) : (
                          <>
                            <fieldset>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Grid container justifyContent="space-around">
                                  <DatePicker
                                    variant="inline"
                                    id="date-picker-dialog"
                                    label="From Date"
                                    name="from"
                                    format="dd/MM/yyyy"
                                    maxDate={new Date()}
                                    value={this.state.fromdate}
                                    onChange={this.handleFromDateChange}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                      />
                                    )}
                                    autoOk={true}
                                  />
                                </Grid>
                              </LocalizationProvider>
                            </fieldset>

                            <fieldset style={{ marginLeft: "30px" }}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Grid container justifyContent="space-around">
                                  <DatePicker
                                    variant="inline"
                                    id="date-picker-dialog"
                                    label="To Date"
                                    name="to"
                                    format="dd/MM/yyyy"
                                    minDate={this.state.fromdate}
                                    value={this.state.todate}
                                    onChange={this.handleToDateChange}
                                    maxDate={new Date()}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                      />
                                    )}
                                    autoOk={true}
                                  />
                                </Grid>
                              </LocalizationProvider>
                            </fieldset>
                            <fieldset className="form-group col-md-1">
                              <button
                                className="btn btn-sm hovbuttonColour mt-3"
                                type="submit"
                              >
                                <i className="fas fa-filter" />
                              </button>
                            </fieldset>

                            <fieldset className="col-md-12">
                              <ThemeProvider theme={theme}>
                                <MUIDataTable
                                  className="table-sm"
                                  id="dirstock"
                                  title={"Inventory Ledger/Stock Transactions" + `(${this.state.item})`}
                                  data={this.state.filtereddata}
                                  columns={columns}
                                  options={options}
                                  // components={components}
                                />
                              </ThemeProvider>

                              {/* <Paper
                                sx={{
                                  width: "100%",
                                  overflow: "hidden",
                                  marginTop: "5px",
                                }}
                              >
                                <TableContainer sx={{ maxHeight: 500 }}>
                                  <Typography className="px-5 pt-3 d-flex justify-content-between">
                                    <h5> Inventory Ledger</h5>
                                    {this.state.showsearchbar ? (
                                      <div>
                                        <TextField
                                          className="mr-2"
                                          placeholder="Search"
                                          value={this.state.search}
                                          onChange={(e) =>
                                            this.Search(e.target.value)
                                          }
                                          id="standard-basic"
                                          variant="standard"
                                        />
                                        <span
                                          className="cursorPointer"
                                          onClick={() =>
                                            this.setState({
                                              showsearchbar: false,
                                              filteredbatchstockdata:
                                                this.state.data,
                                              search: "",
                                            })
                                          }
                                        >
                                          <Tooltip title="Search">
                                            <CloseIcon />
                                          </Tooltip>
                                        </span>
                                      </div>
                                    ) : (
                                      <span
                                        className="cursorPointer"
                                        onClick={() =>
                                          this.setState({ showsearchbar: true })
                                        }
                                      >
                                        <Tooltip title="Search">
                                          <SearchIcon />
                                        </Tooltip>
                                      </span>
                                    )}
                                  </Typography>
                                  <Table
                                    size="small"
                                    stickyHeader
                                    aria-label="sticky table"
                                  >
                                    <TableHead>
                                      <TableRow >
                                        <TableCell  />
                                        <TableCell>Batch Id</TableCell>
                                        <TableCell >Stock Type</TableCell>
                                        <TableCell >Inward</TableCell>
                                        <TableCell >Outward</TableCell>
                                        <TableCell >Previous Stock</TableCell>
                                        <TableCell >In Stock</TableCell>
                                        <TableCell >Out Stock</TableCell>
                                        <TableCell >Current Stock</TableCell>
                                        <TableCell >Date</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {this.state.filtereddata
                                        .slice(
                                          this.state.page *
                                            this.state.rowsPerPage,
                                          this.state.page *
                                            this.state.rowsPerPage +
                                            this.state.rowsPerPage
                                        )
                                        .map((row, idx) => (
                                          <Row key={idx} row={row} />
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                <TablePagination
                                  rowsPerPageOptions={[10, 25, 100]}
                                  component="div"
                                  count={this.state.filtereddata.length}
                                  rowsPerPage={this.state.rowsPerPage}
                                  page={this.state.page}
                                  onPageChange={this.handleChangePage}
                                  onRowsPerPageChange={
                                    this.handleChangeRowsPerPage
                                  }
                                />
                              </Paper> */}
                            </fieldset>
                          </>
                        )}
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

// function Row(props) {
//   const { row } = props;
//   const [open, setOpen] = React.useState(false);
//   return (
//     <React.Fragment>
//       <TableRow
//         sx={{ "& > *": { border: "unset" } }}
//         className={`${open ? "bg-light" : ""}`}
//       >
//         <TableCell className="border">
//           {row.finalproduct !== null &&
//           row.finalproduct.length > 0 ? (
//             <IconButton
//               aria-label="expand row"
//               size="small"
//               onClick={() => setOpen(!open)}
//             >
//               {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
//             </IconButton>
//           ) : (
//             ""
//           )}
//         </TableCell>
//         <TableCell className="border">{row.custombatchid}</TableCell>
//         {/* <TableCell className="border">{row.itemname}</TableCell>
//         <TableCell className="border">{row.category}</TableCell> */}
//         <TableCell className="border">{row.type}</TableCell>
//         <TableCell className="border">{row.from}</TableCell>
//         <TableCell className="border">{row.to}</TableCell>
//         <TableCell className="text-right border">{row.previousstock}</TableCell>
//         <TableCell className="text-success text-right border">
//           {row.quantity > 0 ? row.quantity : 0}
//         </TableCell>
//         <TableCell className="text-danger text-right border">
//           {row.quantity > 0 ? 0 : row.quantity}
//         </TableCell>
//         <TableCell className="text-right border">{row.totalstock}</TableCell>
//         <TableCell>{moment(row.date).format("DD-MM-YYYY HH:mm")}</TableCell>
//       </TableRow>
//       {/* {row.productiontransactionreport !== null &&
//       row.productiontransactionreport.length > 0 ? (
//         <TableRow className={`${open ? "bg-light" : ""}`}>
//           <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
//             <Collapse in={open} timeout="auto" unmountOnExit>
//               <Box>
//                 <Table className="table border" size="small">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell className="text-center item-center">
//                         Workcenter/Production Unit
//                       </TableCell>
//                       <TableCell className="text-center">From</TableCell>
//                       <TableCell className="text-center">To</TableCell>
//                       <TableCell className="text-center">Quantity</TableCell>
//                       <TableCell className="text-center">
//                         Consumption Date
//                       </TableCell>
//                       <TableCell className="text-center"></TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {row.productiontransactionreport?.map((historyRow, i) => (
//                       <TableRow key={i}>
//                         <TableCell className="text-center">
//                           {historyRow.workcenter}
//                         </TableCell>
//                         <TableCell className="text-center">
//                           {historyRow.from}
//                         </TableCell>
//                         <TableCell className="text-center">
//                           {historyRow.to}
//                         </TableCell>
//                         <TableCell className="text-center">
//                           {historyRow.quantity}
//                         </TableCell>
//                         <TableCell className="text-center">
//                           {moment(historyRow.createdAt).format(
//                             "DD-MM-YYYY HH:mm"
//                           )}
//                         </TableCell>
//                         <TableCell className="text-center">
//                           {historyRow.finalproduct !== null &&
//                           historyRow.finalproduct.length > 0 ? (
//                             <Table className="border" size="small">
//                               <TableHead>
//                                 <TableRow>
//                                   <TableCell>Itemname</TableCell>
//                                   <TableCell>Quantity</TableCell>
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {historyRow.finalproduct?.map((e, i) => (
//                                   <TableRow key={i}>
//                                     <TableCell>{e.itemname}</TableCell>
//                                     <TableCell>
//                                       {e.quantity}
//                                       {e.uom}
//                                     </TableCell>
//                                   </TableRow>
//                                 ))}
//                               </TableBody>
//                             </Table>
//                           ) : (
//                             ""
//                           )}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Box>
//             </Collapse>
//           </TableCell>
//         </TableRow>
//       ) : (
//         ""
//       )} */}

//       {row.finalproduct !== null && row.finalproduct.length > 0 ? (
//         <TableRow className={`${open ? "bg-light" : ""}`}>
//           <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
//             <Collapse in={open} timeout="auto" unmountOnExit>
//               <Box>
//                 <Table className="border" size="small">
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Itemname</TableCell>
//                       <TableCell>Quantity</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {row.finalproduct?.map((e, i) => (
//                       <TableRow key={i}>
//                         <TableCell>{e.itemname}</TableCell>
//                         <TableCell>
//                           {e.quantity}
//                           {e.uom}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Box>
//             </Collapse>
//           </TableCell>
//         </TableRow>
//       ) : (
//         ""
//       )}
//     </React.Fragment>
//   );
// }

export default withRouter(Transactionreports);
